import { css } from '@emotion/react'

export const outer = css`
  display: none;
  @media (min-width: 1280px) {
    display: block;
    position: sticky;
    top: 4.75rem;
    margin-right: -1.5rem;
    height: calc(100vh - 4.75rem);
    flex: none;
    overflow-y: auto;
    padding-top: 4rem;
    padding-bottom: 4rem;
    padding-right: 1.5rem;
  }
`

export const navWidth = css`
  width: 15rem;
`

export const titleCss = css`
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin-left: 1rem;
  font-weight: 500;
  color: #0f172a;
`

export const rail = css`
  margin-top: 1rem;
  margin-left: 1rem;
  border-left: 4px solid #e5e7eb;
  padding-left: 1rem;
`

export const rootList = css`
  list-style: none;
  padding: 0;
  font-size: 0.875rem;
  line-height: 1.25rem;

  & > li + li {
    // margin-top: 0.75rem;
  }
`

export const h3Reset = css`
  margin: 0;
  font: inherit;
`

export const linkRow = css`
  display: flex;
  align-items: center;
  height: 36px;
  padding-left: 0.75rem;
  padding-right: 0.25rem;
  text-decoration: none;
  transition: color 150ms ease;
  position: relative;
`

export const linkActive = css`
  color: #0f172a;
  font-weight: 600;

  &::before {
    content: '';
    position: absolute;
    left: -1.25rem;
    top: 4px;
    bottom: 4px;
    width: 4px;
    background: #0ea5e9;
    border-radius: 2px;
    z-index: 1;
  }
`

export const linkInactive = css`
  color: #64748b;
  font-weight: 400;
  &:hover {
    color: #334155;
  }
`

export const childList = css`
  margin-top: 0.5rem;
  padding-left: 0.75rem;
  list-style: none;

  & > li + li {
    margin-top: 0.75rem;
  }
`

export const childLinkRow = css`
  display: flex;
  align-items: center;
  height: 32px;
  padding-left: 0.75rem;
  padding-right: 0.25rem;
  text-decoration: none;
  color: #64748b;
  transition: color 150ms ease;
  position: relative;
`

export const childLinkActive = css`
  color: #0f172a;
  font-weight: 600;

  &::before {
    content: '';
    position: absolute;
    left: -0.75rem;
    top: 4px;
    bottom: 4px;
    width: 4px;
    border-radius: 2px;
    z-index: 1;
  }
`

export const childLinkInactive = css`
  &:hover {
    color: #475569;
  }
`

export const truncateText = css`
  display: block;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`
